/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Cash_LinkInputs */

const vi_dashboard_manager_cash_link = /** @type {(inputs: Dashboard_Manager_Cash_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem báo cáo dòng tiền`)
};

/**

* @param {Dashboard_Manager_Cash_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_cash_link = /** @type {((inputs?: Dashboard_Manager_Cash_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Cash_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_cash_link(inputs)
});